import { InputAddon, InputCurrency, InputGroup } from '../../../../../../../components';
import { canEditOfferFinalPrice } from '../../../../store/offer-store';
import { useOfferInlineEdit } from './hooks/useOfferInlineEdit';
import type { IRowData } from './OfferTable';
import styles from './OfferTable.module.scss';

interface OfferPriceCellProps {
  rowData: IRowData;
  campaignId: string;
  disabled?: boolean;
}

export const OfferPriceCell = ({ rowData, campaignId, disabled = false }: OfferPriceCellProps) => {
  const { localPrice, onPriceChange, onPriceBlur } = useOfferInlineEdit(rowData, campaignId);

  return (
    <InputGroup className={styles['input-addon-gray']}>
      <InputAddon>R$</InputAddon>
      <InputCurrency
        value={localPrice}
        decimalSeparator=","
        thousandSeparator="."
        precision="2"
        allowEmpty
        allowNegative={false}
        disabled={disabled || !canEditOfferFinalPrice(rowData.offer_dto?.offer?.offer_type)}
        onChangeEvent={(_e: unknown, _m: unknown, v: number | null) => onPriceChange(v)}
        onBlur={onPriceBlur}
      />
    </InputGroup>
  );
};
